// src/store/modules/sites.js
import axios from '@/plugins/axios';

const state = {
    sites: [], // 存储所有站点
};

const getters = {
    /**
     * 获取所有站点，按 sortRank 排序
     */
    allSites: (state) =>
        [...state.sites].sort((a, b) => a.sortRank - b.sortRank),

    /**
     * 根据 section ID 获取站点
     * @param {Function} state - Vuex state
     * @returns {Function} - 返回筛选函数
     */
    sitesBySection: (state) => (sectionId) =>
        state.sites
            .filter((site) => site.sectionId === sectionId)
            .sort((a, b) => a.sortRank - b.sortRank),
};

const actions = {
    /**
     * 获取所有站点数据
     */
    async fetchSites({ commit }) {
        try {
            const response = await axios.get('/admin/sites/getSites');
            console.log('API Response (fetchSites):', response);
            if (response && response.code === 200 && Array.isArray(response.data.sites)) {
                commit('setSites', response.data.sites);
            } else {
                console.error('API 返回的数据结构不正确:', response);
            }
        } catch (error) {

            console.error('获取站点数据失败:', error);
            throw error;
        }
    },

    /**
     * 添加站点
     * @param {Object} siteData - 站点数据
     */
    async addSite({ commit }, siteData) {
        try {
            const response = await axios.post('/admin/sites/addSite', siteData);
            if (response.code === 200 && response.data) {
                commit('addSite', response.data);
            } else {
                console.error('添加站点失败:', response.msg);
                throw new Error(response.msg || '添加站点失败');
            }
        } catch (error) {
            console.error('添加站点失败:', error);
            throw error;
        }
    },

    /**
     * 更新站点
     * @param {Object} siteData - 更新后的站点数据
     */
    async updateSite({ commit }, siteData) {
        try {
            const response = await axios.put(`/admin/sites/updateSite/${siteData.siteId}`, siteData);
            if (response.code === 200 && response.data) {
                // commit('updateSite', response.data);
            } else {
                console.error('更新站点失败:', response.msg);
                throw new Error(response.msg || '更新站点失败');
            }
        } catch (error) {
            console.error('更新站点失败:', error);
            throw error;
        }
    },

    /**
     * 删除站点
     * @param commit
     * @param {Number} siteId - 站点 ID
     * @param sectionId
     */
    async deleteSite({ commit }, {siteId, sectionId}) {
        try {

            const response = await axios.post(`/admin/sites/deleteSite`,{ siteId, sectionId });
            if (response.code === 200) {
                commit('deleteSite', siteId);
            } else {
                console.error('删除站点失败:', response.msg);
                throw new Error(response.msg || '删除站点失败');
            }
        } catch (error) {
            console.error('删除站点失败:', error);
            throw error;
        }
    },

    /**
     * 重排站点顺序
     * @param {Object} payload - 包含 sectionId 和 sites 的对象
     */
    async reorderSites({ commit }, { sectionId, sites }) {
        try {
            const response = await axios.post('/admin/sites/reorderSites', { sectionId, sites });
            if (response.code === 200) {
                commit('setSitesForSection', { sectionId, sites });
            } else {
                console.error('重排站点失败:', response.msg);
                throw new Error(response.msg || '重排站点失败');
            }
        } catch (error) {
            console.error('重排站点失败:', error);
            throw error;
        }
    },
};

const mutations = {
    /**
     * 设置所有站点
     * @param {Object} state - Vuex state
     * @param {Array} sites - 站点数组
     */
    setSites(state, sites) {
        state.sites = sites;
    },

    /**
     * 添加站点
     * @param {Object} state - Vuex state
     * @param {Object} site - 新添加的站点
     */
    addSite(state, site) {
        state.sites.push(site);
    },

    /**
     * 更新站点
     * @param {Object} state - Vuex state
     * @param {Object} updatedSite - 更新后的站点
     */
    updateSite(state, updatedSite) {

        const index = state.sites.findIndex((site) => site.siteId === updatedSite.siteId);


        console.log('当前 state.sites:', state.sites);
        console.log('更新的站点对象:', updatedSite);
        console.log('updatedSite.siteId 类型:', typeof updatedSite.siteId);
        if (index !== -1) {
            state.sites.splice(index, 1, updatedSite);
        } else {
            console.error('找不到对应的站点，无法更新');
        }
    },

    /**
     * 删除站点
     * @param {Object} state - Vuex state
     * @param {Number} siteId - 站点 ID
     */
    deleteSite(state, siteId) {
        state.sites = state.sites.filter((site) => site.siteId !== siteId);
    },

    /**
     * 设置指定分栏的站点列表
     * @param {Object} state - Vuex state
     * @param {Object} payload - 包含 sectionId 和 sites 的对象
     */
    setSitesForSection(state, { sectionId, sites }) {
        // 移除当前分栏的所有站点
        state.sites = state.sites.filter((site) => site.sectionId !== sectionId);
        // 添加重新排序后的站点
        state.sites = state.sites.concat(sites);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
